module.exports = __webpack_public_path__ + "static/img/partner3.b16da14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/partner3.png
// module id = zGEL
// module chunks = 202